<span class="field-value">
  <span *ngIf="showFlag && languageFlag" class="language-flag">{{ languageFlag }}</span>
  <span class="field-view-value">{{ languageName }}</span>
</span>
